// InvoicesFilter.jsx
import React from "react";
import "./Invoices.css";

const statusTypes = [
  { value: "Todos", label: "Todos" },
  { value: "processing", label: "Em Análise" },
  { value: "authorized", label: "Autorizado" },
  { value: "paid", label: "Pago" },
  { value: "refunded", label: "Estornado" },
  { value: "waiting_payment", label: "Aguardando Pagamento" },
  { value: "pending_refund", label: "Aguardando Estorno" },
  { value: "refused", label: "Cancelada Pagarme" },
  { value: "cancelled", label: "Manual" },
  { value: "analyzing", label: "Em Análise Manual" },
  { value: "pendent", label: "Pendente" },
];

const deliveryTypes = [
  { value: "Todos", label: "Todos" },
  { value: "jadlog", label: "Jadlog" },
  { value: "correios", label: "Correios" },
  { value: "motoboy", label: "Motoboy" },
  { value: "presencial", label: "Presencial" },
];

const channelTypes = [
  { value: "Todos", label: "Todos" },
  { value: "presencial", label: "Presencial" },
  { value: "online", label: "Online" },
];

/**
 * Painel lateral de filtros da tela de Vendas. Os campos só mudam o state
 * do pai; quem consulta é "Aplicar filtros" (onSubmitFilters).
 */
const InvoicesFilter = ({
  start,
  end,
  searchProduct,
  selectedType,
  selectedTypeDelivery,
  selectedChannel,
  onChangeStartDate,
  onChangeEndDate,
  onSearchProduct,
  onSearchProductByStatus,
  onSearchProductByDelivery,
  onChangeChannel,
  onSubmitFilters,
  onClear,
}) => (
  <aside className="sales-card sales-filters">
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmitFilters();
      }}
    >
      <header className="sales-card__header">
        <h2 className="sales-card__title">Filtros</h2>
        {onClear && (
          <button
            type="button"
            className="sales-filters__clear"
            onClick={onClear}
          >
            Limpar
          </button>
        )}
      </header>

      <div className="sales-filters__group">
        <span className="sales-filters__label">Período</span>
        <div className="sales-filters__dates">
          <input
            type="date"
            aria-label="Data inicial"
            className="sales-input"
            value={start || ""}
            onChange={(e) => onChangeStartDate(e.target.value)}
          />
          <input
            type="date"
            aria-label="Data final"
            className="sales-input"
            value={end || ""}
            onChange={(e) => onChangeEndDate(e.target.value)}
          />
        </div>
      </div>

      <label className="sales-filters__group">
        <span className="sales-filters__label">Cliente</span>
        <input
          type="text"
          className="sales-input"
          placeholder="Pesquisar comprador"
          value={searchProduct}
          onChange={(e) => onSearchProduct(e.target.value)}
        />
      </label>

      {onChangeChannel && (
        <label className="sales-filters__group">
          <span className="sales-filters__label">Canal de venda</span>
          <select
            className="sales-select"
            value={selectedChannel || "Todos"}
            onChange={(e) => onChangeChannel(e.target.value)}
          >
            {channelTypes.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </label>
      )}

      <label className="sales-filters__group">
        <span className="sales-filters__label">Status do pedido</span>
        <select
          className="sales-select"
          value={selectedType || "Todos"}
          onChange={(e) => onSearchProductByStatus(e.target.value)}
        >
          {statusTypes.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </label>

      <label className="sales-filters__group">
        <span className="sales-filters__label">Tipo de entrega</span>
        <select
          className="sales-select"
          value={selectedTypeDelivery || "Todos"}
          onChange={(e) => onSearchProductByDelivery(e.target.value)}
        >
          {deliveryTypes.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      </label>

      <button
        type="submit"
        className="cp-btn cp-btn--primary sales-filters__apply"
      >
        Aplicar filtros
      </button>
    </form>
  </aside>
);

export default InvoicesFilter;
